import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "../services/authTokenStore";

export const baseUrl = process.env.REACT_APP_API_URL || "https://localhost:6001";

export const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}/api/v1/`,
  prepareHeaders: (headers, { getState }) => {
    const accessToken = getAccessToken();
    const seamlessToken = getState()?.seamlessToken?.token;
    const tokenToUse = accessToken || seamlessToken;

    if (tokenToUse) {
      headers.set("Authorization", `Bearer ${tokenToUse}`);
    }

    return headers;
  }
});

export const getApiUrl = `${baseUrl}/api/v1/`;